import { PassouFalhouEnum } from '@mchat-rf/consulta-seguimento/enums-consultaSeguimento'
import { hasAnySim, isAllFilled, isAllNao } from '@mchat-rf/consulta-seguimento/utils-consultaSeguimento'
import { isEmpty } from 'util/checks'

import {
  ConsultaSeguimentoPergunta10ExemplosEnum,
  ConsultaSeguimentoPergunta10Model,
} from './model-consultaSeguimentoPergunta10'

const pergunta10ExemplosPassouEnumValues = [
  ConsultaSeguimentoPergunta10ExemplosEnum.PROCURA,
  ConsultaSeguimentoPergunta10ExemplosEnum.FALA_OU_EMITE_SOM,
  ConsultaSeguimentoPergunta10ExemplosEnum.PARA_O_QUE_ESTA_FAZENDO,
]
const pergunta10ExemplosFalhouEnumValues = [
  ConsultaSeguimentoPergunta10ExemplosEnum.NAO_DA_RESPOSTA,
  ConsultaSeguimentoPergunta10ExemplosEnum.PARECE_OUVIR_IGNORA,
  ConsultaSeguimentoPergunta10ExemplosEnum.SO_RESPONDE_NA_FRENTE,
  ConsultaSeguimentoPergunta10ExemplosEnum.SO_RESPONDE_SE_TOCADO,
]

export function isPergunta10ExemplosAllFilled(
  value: ConsultaSeguimentoPergunta10Model['PERGUNTA_10_EXEMPLOS']
): boolean {
  return (
    isAllFilled(value?.PASSOU, pergunta10ExemplosPassouEnumValues) &&
    isAllFilled(value?.FALHOU, pergunta10ExemplosFalhouEnumValues)
  )
}

export function isPergunta10ExemplosAllNao(value: ConsultaSeguimentoPergunta10Model['PERGUNTA_10_EXEMPLOS']): boolean {
  return (
    isAllNao(value?.PASSOU, pergunta10ExemplosPassouEnumValues) &&
    isAllNao(value?.FALHOU, pergunta10ExemplosFalhouEnumValues)
  )
}

export function hasPergunta10ExemplosPassouAnySim(
  value: ConsultaSeguimentoPergunta10Model['PERGUNTA_10_EXEMPLOS']
): boolean {
  return hasAnySim(value?.PASSOU)
}

export function hasPergunta10ExemplosFalhouAnySim(
  value: ConsultaSeguimentoPergunta10Model['PERGUNTA_10_EXEMPLOS']
): boolean {
  return hasAnySim(value?.FALHOU)
}

export function prunePergunta10(value: ConsultaSeguimentoPergunta10Model): ConsultaSeguimentoPergunta10Model {
  const pruned: ConsultaSeguimentoPergunta10Model = {
    status: value.status,
    resultado: value.resultado,
    PERGUNTA_10_HEADER: value.PERGUNTA_10_HEADER,
    PERGUNTA_10_EXEMPLOS: value.PERGUNTA_10_EXEMPLOS,
  }

  const hasPerguntaExemplosPassouAnySim = hasPergunta10ExemplosPassouAnySim(value?.PERGUNTA_10_EXEMPLOS)
  const hasPerguntaExemplosFalhouAnySim = hasPergunta10ExemplosFalhouAnySim(value?.PERGUNTA_10_EXEMPLOS)

  if (hasPerguntaExemplosPassouAnySim && hasPerguntaExemplosFalhouAnySim) {
    pruned.PERGUNTA_10_FREQUENCIA = value.PERGUNTA_10_FREQUENCIA
  }

  return pruned
}

export function conditionToCalculatePergunta10(values: ConsultaSeguimentoPergunta10Model): boolean {
  if (
    !isPergunta10ExemplosAllFilled(values.PERGUNTA_10_EXEMPLOS) ||
    isPergunta10ExemplosAllNao(values?.PERGUNTA_10_EXEMPLOS)
  ) {
    return false
  }

  const hasPerguntaExemplosPassouAnySim = hasPergunta10ExemplosPassouAnySim(values.PERGUNTA_10_EXEMPLOS)
  const hasPerguntaExemplosFalhouAnySim = hasPergunta10ExemplosFalhouAnySim(values.PERGUNTA_10_EXEMPLOS)

  if (
    (hasPerguntaExemplosPassouAnySim && !hasPerguntaExemplosFalhouAnySim) ||
    (hasPerguntaExemplosFalhouAnySim && !hasPerguntaExemplosPassouAnySim)
  ) {
    return true
  } else {
    return !isEmpty(values.PERGUNTA_10_FREQUENCIA)
  }
}

export function calculateResultadoPergunta10(values: ConsultaSeguimentoPergunta10Model): PassouFalhouEnum | undefined {
  const hasPerguntaExemplosPassouAnySim = hasPergunta10ExemplosPassouAnySim(values.PERGUNTA_10_EXEMPLOS)
  const hasPerguntaExemplosFalhouAnySim = hasPergunta10ExemplosFalhouAnySim(values.PERGUNTA_10_EXEMPLOS)

  if (hasPerguntaExemplosPassouAnySim && !hasPerguntaExemplosFalhouAnySim) {
    return PassouFalhouEnum.PASSOU
  } else if (hasPerguntaExemplosFalhouAnySim && !hasPerguntaExemplosPassouAnySim) {
    return PassouFalhouEnum.FALHOU
  } else {
    return values.PERGUNTA_10_FREQUENCIA
  }
}
